import { Home } from "@/components/home/Home";
import { RouteConfig } from "@/config/route.config";
import { AuthGuard } from "@/data/auth/AuthGuard";

export default function HomePage() {
  return (
    <AuthGuard
      type="private"
      requireOnboarding
      redirectTo={RouteConfig.Signin}
    >
      <Home />
    </AuthGuard>
  );
}
